import React              from "react"
import config             from "../../../featureflags.json"
import Layout             from "../../components/layouts/layout"
import { graphql }        from "gatsby"
import AdjacentLinks      from "../../template-parts/sidebar/adjacentlinks"
import PostBanner         from "../../template-parts/postbanner"
import Callout            from "../../template-parts/sidebar/callout"
import RelatedLinks       from "../../template-parts/sidebar/relatedlinks"
import DownloadableFiles  from "../../template-parts/sidebar/downloads"
import StepBySteps        from "../../template-parts/sidebar/stepbystep"
import ContactCallout     from "../../template-parts/sidebar/contact"
import YoastSEO           from "../../template-parts/head/seo"
import Breadcrumbs        from "../../template-parts/blocks/breadcrumbs"
import InnerAlert         from "../../template-parts/alerts/page"
import AdSidebar          from "../../template-parts/sidebar/ads/"
import Form               from "../../template-parts/formToDisplay/"
import NextBackButtons    from "../../template-parts/sidebar/stepbystep/NextBackButtons"
import _                  from "lodash"

const FLAG_SHOWPOSTCONTENT = config.FLAG_SHOWPOSTCONTENT;

//import Alert from "../../template-parts/alerts/Alert.js";
export default function BlogPost({ data }) { 
  const post                = data.post.nodes[0];
  const postsOrder          = data.orderedData.nodes[0].contentOrder.postsInCategory;
  const termsOrder          = data.orderedData.nodes[0].contentOrder.termsInCategory;

  let content           = post.content;
  if( (post) && (post.content !== null)){
    content             = post.content.replace('<ul role="directory" class="wp-block-sgc-toc-summary__list">', '<ul role="list" class="wp-block-sgc-toc-summary__list">');
    content.replace('<ol role="directory" class="wp-block-sgc-toc-summary__list">', '<ol role="list" class="wp-block-sgc-toc-summary__list">');
  } 


  const breadcrumbs         = data.post.nodes[0].seo.breadcrumbs
  const yoast               = data.post.nodes[0].seo
  const callout             = post.acf_calloutSidebar.calloutRelationship;
  const relatedLinks        = post.acf_relatedLinks;
  const downloadableFiles   = post.acf_downloads.downloads;
  const form                = post.acf_formDisplay;
  //const alerts              = post.alerts;
  let alertInfo             = null;
  let contactPageInfo       = null;
  const contactSidebar      = post.acf_ContactDetails;
  const steps               = data.StepbyStep;
  let stepsInfo             = null;
  let stepParentInfo        = null;
  let postLayout            = post.acf_PostLayout.postLayout;
  let bannerArea            = null;
  let adjacentLinks = '';
  let formRender;
 //console.log(form)

  if(postLayout ==='herobanner') {
    bannerArea = post.acf_bannerArea;
  }

  const filter = (arr, name, value) => arr.filter((obj) => (name in obj && obj[name] === value)).map((obj) => {
    const nObj = { ...obj };
    if (obj.content && Array.isArray(obj.content)) {
      nObj.content = filter(obj.content, name, value);
    }
    return nObj;
  });

  if(!_.isNil(post.StepbyStep)) {
    post.StepbyStep.nodes.forEach(StepByStep => {
      if(!_.isEmpty(StepByStep.wpChildren.nodes)) {
        const merged = _.merge( _.keyBy(StepByStep.wpChildren.nodes, 'databaseId'),_.keyBy(termsOrder, 'term_id'));
        let newArray = []
      _.forEach(merged, function(value) {
        //console.log(value.databaseId)
        if(value.databaseId !== undefined){
          newArray.push(
            value
          )
        }
      });
       //console.log(newArray);
       stepsInfo      = _.orderBy(newArray, ['term_order'],['asc']) ;
       stepParentInfo = {
         stepperName: StepByStep.name,
         stepperUri:  StepByStep.slug
       }
       //console.log(post.StepbyStep);
       //console.log(stepsInfo);
      }
    })


   // stepsInfo = post.StepbyStep
 
  } else {
    stepsInfo = null
  }

  if(contactSidebar !== null) {
    contactPageInfo = {
      contactPage: {
        title : post.title,
        url   : post.slug
      },
      contactSidebar : post.acf_ContactDetails 
    }
  }

 if(post.categories.nodes[0]) {
    const currentCategoryID   = post.categories.nodes[0].databaseId;
    const postsInOrder  = filter(postsOrder, "category_id", currentCategoryID);
    let merged = _.merge( _.keyBy(post.categories.nodes[0].posts.nodes, 'databaseId'),_.keyBy(postsInOrder, 'post_id'));
    merged =  Object.entries(_.orderBy(merged, ['id'],['asc']));
    adjacentLinks = {
      sidebarHeader: {
        sidebarTitle:post.categories.nodes[0].name,
        sidebarLink:post.categories.nodes[0].uri
      },

      sidebarLinks: merged,
    }
  }else {
    adjacentLinks = null
  }

 

  if(!_.isNil(form)){
    formRender = form.whichFormToDisplay;
  }

  return (
    <Layout>
      <YoastSEO seoData={yoast} title={post.title} wpSiteID={post.databaseId} wpContentType="post"/>
      <PostBanner data={bannerArea} />
      <div className="page-container container">
      <Breadcrumbs breadcrumbData={breadcrumbs} />
        <div className="page-content row">
          <div className="col-md-8 col-xs-12">
            {!post.acf_bannerArea.bannerAreaTitle && 
              <div className="page-header">
                <h1>{post.title}</h1>
              </div>
            }
            <Form data={formRender}/>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <NextBackButtons data={stepsInfo} currentURL={post.slug} stepperInfo={stepParentInfo}/>  
          </div>
          <aside className="sidebar col-md-4 col-xs-12" aria-label="Additional information and links">
           
            <StepBySteps data={stepsInfo} currentURL={post.slug} stepperInfo={stepParentInfo}/>  
            <AdjacentLinks data={adjacentLinks}/>
            <Callout data={callout}/>
            <ContactCallout data={contactPageInfo}/>
            <DownloadableFiles data={downloadableFiles} />
            <RelatedLinks data={relatedLinks} />
            <AdSidebar/>
          </aside>
        </div>  
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    post: allWpPost(filter: {slug: {eq: $slug}}) {
      nodes {
        title
        content
        slug
        uri
        databaseId
        id
        categories {
          nodes {
            name
            uri
            databaseId
            posts {
              nodes {
                title
                uri
                databaseId
              }
            }
          }
        }

        acf_PostLayout {
          postLayout
        }
        acf_bannerArea {
          bannerAreaImage {
            localFile {
              localURL
            }
            altText
          }
          bannerAreaBackgroundcolour
          bannerArea
          bannerAreaText
          bannerAreaTitle
        }

        seo {
          canonical
          title
          metaDesc
          focuskw
          metaRobotsNoindex
          metaRobotsNofollow
         
          breadcrumbs {
              url
              text
          }
          
      }
      StepbyStep: ql_StepbySteps {
        nodes {
          name
          slug
          uri
          wpChildren {
            nodes {
              name
              slug
              databaseId
              description
              posts {
                nodes {
                  title
                  slug
                  uri
                }
              }
            }
          }
        }
      }

        acf_calloutSidebar {
          calloutRelationship {
            ... on WpQl_sidebarcallouts {
              id
              title
              content
            }
          }
        }
        acf_ContactDetails {
          contactDetails {
            ... on WpQl_contact {
              id
              contact {
                address
                email
                telephone
                website
              }
              title
            }
          }
          contactDetailsHideAddress
          contactDetailsHideEmail
          contactDetailsHideTelephone
        }
     
        acf_relatedLinks {
          relatedLinks {
            text
            url
          }
        }
        acf_downloads {
          downloads {
            file {
              localFile {
                localURL
                name
              }
              guid
              title
            }
            title
          }
        }
        acf_formDisplay {
          whichFormToDisplay
        }
      } 
    }
    orderedData: allWp {
      nodes {
        contentOrder {
          postsInCategory {
            category_id
            incl
            id
            post_id
          }
          termsInCategory {
            term_id
            term_order
            slug
          }
        }
      }
    }
  }
`